import {setStore} from '../../../../src/utility/setStore'
export default {
    SET_SERVICES(state,data) {
        state.services = data;
        //setStore('moduleName','Key',value)
        setStore('website','services,list',data)
    },
    SET_SERVICE_STATUS(state,data) {
        state.serviceStatus = data;
        //setStore('moduleName','Key',value)
        setStore('website','services,serviceStatus',data)
    },
    SET_CURRENT_SERVICE(state,data) {
        state.currentService = data;
        //setStore('moduleName','Key',value)
        setStore('website','services,currentService',data)
    },
    SET_COVERAGE_PHOTOS(state,data) {
        state.coveragePhotos = data;
        //setStore('moduleName','Key',value)
        setStore('website','services,coveragePhotos,list',data)
    },
    SET_COVERAGE_PHOTO_STATUS(state,data) {
        state.coveragePhotoStatus = data;
        //setStore('moduleName','Key',value)
        setStore('website','services,coveragePhotos,coveragePhotoStatus',data)
    },
    SET_CURRENT_COVERAGE_PHOTO(state,data) {
        state.currentCoveragePhoto = data;
        //setStore('moduleName','Key',value)
        setStore('website','services,coveragePhotos,currentCoveragePhoto',data)
    },
};
